var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "top-nav" }, [
        _c(
          "nav",
          {
            staticClass: "navbar navbar-expand-lg navbar-light",
            attrs: { "aria-label": "Menu główne" },
          },
          [
            _c("div", { staticClass: "container-fluid" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "d-block d-lg-none ms-auto" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "dropdown-menu rounded-1 dropdown-menu-end",
                    attrs: { "aria-labelledby": "login-selector1" },
                  },
                  [
                    _c("li", {}, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          attrs: {
                            target: "_blank",
                            href: "https://ebilet.intercity.pl/profil",
                            role: "button",
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.$t("ic_aside_moje_konto")) + " "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(
                              "Zaloguj się do swojego konta w\n                    systemie eIC - otwiera się w nowej karcie"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("li", {}, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          attrs: {
                            target: "_blank",
                            href: "https://ebilet.intercity.pl/profil/loginkontogosc",
                            role: "button",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ic_aside_uzytkownicy_niezarejestrowani")
                            ) + " "
                          ),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(
                              "przejdź do\n                    konta gość w systemie eIC - otwiera się w nowej karcie"
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "collapse navbar-collapse mega-menu mt-2 mt-lg-auto",
                  attrs: { id: "navbarSupportedContent" },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "navbar-nav ms-auto" },
                    _vm._l(_vm.items, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: {
                            "nav-item": true,
                            "dropdown position-static":
                              item.items && item.items.length,
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              class: {
                                "nav-link": true,
                                "dropdown-toggle":
                                  item.items && item.items.length,
                              },
                              attrs: {
                                href: item.url,
                                role: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false",
                                id: "navbarDropdown" + index,
                              },
                            },
                            [_vm._v(_vm._s(item.label))]
                          ),
                          _vm._v(" "),
                          item.items && item.items.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "dropdown-menu top-auto",
                                  attrs: {
                                    "aria-labelledby": "navbarDropdown" + index,
                                  },
                                },
                                [
                                  _c("div", { staticClass: "container" }, [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "row row-cols-1 row-cols-xl-5 row-cols-md-3 list-unstyled text-small my-2",
                                      },
                                      _vm._l(
                                        item.items,
                                        function (submenu, index2) {
                                          return _c("li", { key: index2 }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "dropdown-item-text",
                                                attrs: {
                                                  href: submenu.url,
                                                  title: submenu.label,
                                                  tabindex_: index + index2,
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mtm mbm" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(submenu.label)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            submenu.items
                                              ? _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "list-unstyled",
                                                  },
                                                  _vm._l(
                                                    submenu.items,
                                                    function (i, ind) {
                                                      return _c(
                                                        "li",
                                                        { key: ind },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "dropdown-item",
                                                              attrs: {
                                                                href: i.url,
                                                                title: i.label,
                                                                tabindex_: ind,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(i.label)
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ])
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "top-utils d-flex align-items-center" },
                    [
                      _c("div", { staticClass: "vr mx-3" }),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "contrast-selector btn btn-ghost",
                          attrs: {
                            type: "button",
                            "aria-label": _vm.changeThemeButtonLabel,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.switchTheme.apply(null, arguments)
                            },
                          },
                        },
                        [_c("i", { staticClass: "bi bi-circle-half" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn font-size-changer no-wrap align-self-center",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "font-size-xs",
                              class: { "fw-bold": _vm.currentSize == "s" },
                              attrs: {
                                "aria-label":
                                  "ustaw standardową wielkość czcionki",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.fontSizeChangerHandleClick("s")
                                },
                              },
                            },
                            [_vm._v("A")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "font-size-sm",
                              class: { "fw-bold": _vm.currentSize == "m" },
                              attrs: {
                                "aria-label": "ustaw większą wielkość czcionki",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.fontSizeChangerHandleClick("m")
                                },
                              },
                            },
                            [_vm._v("A")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "font-size-md",
                              class: { "fw-bold": _vm.currentSize == "l" },
                              attrs: {
                                "aria-label":
                                  "ustaw największą wielkość czcionki",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.fontSizeChangerHandleClick("l")
                                },
                              },
                            },
                            [_vm._v("A")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-ghost dropdown-toggle rounded-1",
                            attrs: {
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false",
                              id: "language-selector",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "img-icon",
                              attrs: {
                                src:
                                  "images/icons/" +
                                  _vm.current.toUpperCase() +
                                  ".svg",
                                alt: "",
                              },
                            }),
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.current.toUpperCase()) +
                                "\n                  "
                            ),
                            _c(
                              "span",
                              { staticClass: "sr-only", attrs: { lang: "en" } },
                              [_vm._v("change language")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "sr-only", attrs: { lang: "ru" } },
                              [_vm._v("изменить язык")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "sr-only", attrs: { lang: "pl" } },
                              [_vm._v("zmień język")]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu rounded-1",
                            attrs: { "aria-labelledby": "language-selector" },
                          },
                          _vm._l(_vm.langs, function (item, index) {
                            return _c("li", { key: index }, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: { href: item.lang },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-icon",
                                    attrs: {
                                      src: "images/icons/" + item.name + ".svg",
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" " + _vm._s(item.name) + " "),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      "zmień język na " + _vm._s(item.full)
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vr" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "d-none d-lg-inline btn btn-ghost dropdown-toggle rounded-1",
                            attrs: {
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              id: "login-selector",
                              "aria-expanded": "false",
                              "aria-label": "Wybierz sposób logowania",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "img-icon",
                              attrs: { src: "images/icons/user.svg", alt: "" },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "d-none d-md-inline-block" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("ic_aside_logowanie_i_rejestracja")
                                  )
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass:
                              "dropdown-menu rounded-1 dropdown-menu-end",
                            attrs: { "aria-labelledby": "login-selector" },
                          },
                          [
                            _c("li", {}, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: {
                                    target: "_blank",
                                    href: "https://ebilet.intercity.pl/profil",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("ic_aside_moje_konto")) + " "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      "Zaloguj się do swojego konta w systemie eIC - otwiera się w nowej\n                        karcie"
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", {}, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: {
                                    target: "_blank",
                                    href: "https://ebilet.intercity.pl/profil/loginkontogosc",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "ic_aside_uzytkownicy_niezarejestrowani"
                                      )
                                    ) + "\n                      "
                                  ),
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      "przejdź do konta gość w systemie eIC - otwiera się w nowej\n                        karcie"
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.showbgimage !== 0
      ? _c("img", {
          staticClass: "top-image",
          attrs: { src: "/images/train_bg.svg", alt: "" },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "navbar-brand",
        staticStyle: { "max-width": "40%" },
        attrs: { href: "/" },
      },
      [
        _c("div", {
          staticClass: "d-block d-md-inline-block img-fluid",
          attrs: {
            src: "/images/logo.svg",
            alt: "PKP INTERCITY LOGO",
            id: "pkp-ic-logo",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-ghost dropdown-toggle",
        attrs: {
          type: "button",
          "data-bs-toggle": "dropdown",
          id: "login-selector1",
          "aria-expanded": "false",
          "aria-label": "Wybierz sposób logowania",
        },
      },
      [_c("i", { staticClass: "bi bi-person-fill" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Menu",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass:
          "btn btn-ghost page-header__ue-dla-pkp d-none d-md-inline-block",
        attrs: { href: "site/o-nas/o-firmie/ue-dla-pkp-ic/" },
      },
      [
        _c("span", { staticClass: "sr-only" }, [
          _vm._v(
            "Informacje na temat wykorzystania\n                  środków z Unii Europejskie w PKP Intercity"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-ghost",
        attrs: {
          href: "/pl/site/dla-pasazera/informacje-dla-osob-z-niepelnosprawnoscia-i-osob-o-ograniczonej-sprawnosci-ruchowej/",
        },
      },
      [
        _c("span", { staticClass: "img-icon img-icon--wheelchair" }),
        _c("span", { staticClass: "sr-only tooltip" }, [
          _vm._v(
            "Informacje dla osób z\n                  niepełnosprawnością\n                  i osób o ograniczonej sprawności ruchowej"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "btn btn-ghost",
        attrs: {
          href: "https://pzgomaz.com/notLogged?customer=PKP_Intercity",
          target: "_blank",
          title: "Tłumacz języka migowego",
        },
      },
      [_c("span", { staticClass: "img-icon img-icon--migam" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }